module.exports = __webpack_public_path__ + "img/zanwushuju.99f944d8.png";